export default __webpack_public_path__ + "static/media/misc-books1-768w.a5b5e88a.avif";